export const reportWebVitals = () => {
  if (typeof window === 'undefined' || !window.PerformanceObserver) return;

  const send = (metric) => {
    if (window.gtag) {
      window.gtag('event', metric.name, {
        event_category: 'Web Vitals',
        value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
        event_label: metric.id,
        non_interaction: true,
      });
    }
  };

  try {
    new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        send({ name: 'LCP', value: entry.startTime, id: entry.id });
      }
    }).observe({ type: 'largest-contentful-paint', buffered: true });

    new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (!entry.hadRecentInput) {
          send({ name: 'CLS', value: entry.value, id: entry.sources?.[0]?.node?.id || 'cls' });
        }
      }
    }).observe({ type: 'layout-shift', buffered: true });

    new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        send({ name: 'FID', value: entry.processingStart - entry.startTime, id: entry.name });
      }
    }).observe({ type: 'first-input', buffered: true });
  } catch {
    // PerformanceObserver not supported
  }
};
